import { CameraAlt } from 'components/icons/CameraAlt'
import { useTranslationTyped } from 'i18n/i18n'

export function PermissionsErrorBanner({
  onDismiss,
}: {
  onDismiss: () => void
}) {
  const { tt } = useTranslationTyped()
  return (
    <div className="fixed top-0 left-0 flex w-full items-center border-b-1 bg-light-grey p-2 text-core-on-secondary">
      <div className="flex w-full flex-row justify-between px-1">
        <div className="flex flex-row">
          <CameraAlt
            size={24}
            className="mr-2 fill-core-on-tertiary stroke-core-secondary"
          />
          <p className="mr-2 text-body-large">
            {tt.pages.av_test.video_not_readable_error_popup()}
          </p>
        </div>
        <div className="flex flex-row">
          <button
            className="mr-4 text-label-large text-grey-text"
            onClick={() =>
              window.open(
                'https://knowledgebase.breakoutlearning.com/audio-video',
                '_blank'
              )
            }
          >
            {tt.navigation.help()}
          </button>
          <button
            className="mr-1 text-label-large text-grey-text"
            onClick={onDismiss}
          >
            {tt.common.ok()}
          </button>
        </div>
      </div>
    </div>
  )
}
